module.exports = __webpack_public_path__ + "static/ohio_bg-69b8e07057551ec34494049556090cb9.jpg";